import PropTypes from 'prop-types';
import css from './Response.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Response = function Response(_ref) {
  var response = _ref.response;
  return /*#__PURE__*/_jsxs("div", {
    className: css.response,
    children: [/*#__PURE__*/_jsx("h5", {
      className: css.title,
      children: "Response from Team OV"
    }), /*#__PURE__*/_jsx("div", {
      className: css.body,
      dangerouslySetInnerHTML: {
        __html: response
      }
    })]
  });
};

Response.propTypes = {
  response: PropTypes.string.isRequired
};
export default Response;